import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { ServiceSummary } from "../../../../../../components/subscription-detail/service-summary/service-summary";
import { EnabledPipe } from "../../../../../../helpers/enabledpipe/enabledpipe";
import { FirewallSubscriptionDetails } from "../../../../../../pages/subscription-detail/types";

export interface IpGatewayInput {
  surfcertFilter: string;
  ipv4Mtu?: number | null;
  ipv6Mtu?: number | null;
  ipPrefixes: string[];
}

@Component({
  selector: "uplink-detail-container",
  templateUrl: "uplink-detail-container.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, TranslatePipe, ServiceSummary, EnabledPipe],
})
export class UplinkDetailContainer {
  protected subscription = input.required<FirewallSubscriptionDetails>();
  protected ipGateway = input.required<IpGatewayInput>();

  protected surfcertFilter = computed(() => this.ipGateway().surfcertFilter);
  protected ipv4Mtu = computed(() => this.ipGateway().ipv4Mtu);
  protected ipv6Mtu = computed(() => this.ipGateway().ipv6Mtu);
  protected ipPrefixes = computed(() => this.ipGateway().ipPrefixes);
}
